import React from 'react';
import { Text } from '../Text';

const MarketingCarouselPreview = ({
  content,
  carouselType,
  carouselCards = [],
  productCards = [],
  productCTAType,
  productCTA,
}) => {
  return (
    <div className="mx-2 mt-2">
      {/* BODY */}
      {content && (
        <Text type="sub-heading" style={{ whiteSpace: 'pre-line' }}>
          {content}
        </Text>
      )}

      {/* CAROUSEL */}
      <div className="flex gap-2 mt-2" style={{ overflowX: 'auto' }}>
        {/* MEDIA CAROUSEL */}
        {carouselType === 'MEDIA' &&
          carouselCards?.map((card, index) => (
            <div
              key={index}
              style={{
                minWidth: '220px',
                background: '#fff',
                borderRadius: '10px',
                padding: '8px',
              }}
            >
              {/* MEDIA */}
              {card?.media && (
                <>
                  {card.media.type?.includes('image') && (
                    <img
                      src={URL.createObjectURL(card.media)}
                      style={{
                        width: '100%',
                        maxHeight: '160px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                      }}
                    />
                  )}

                  {card.media.type?.includes('video') && (
                    <video
                      src={URL.createObjectURL(card.media)}
                      controls
                      style={{
                        width: '100%',
                        maxHeight: '160px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                      }}
                    />
                  )}
                </>
              )}

              {/* TEXT */}
              {card.cardText && <Text type="sub-heading">{card.cardText}</Text>}

              {/* BUTTONS */}
              {card.buttons?.map((btn, i) => (
                <div
                  key={i}
                  className="mt-2 p-2 text-center"
                  style={{
                    background: '#f5f6f7',
                    borderRadius: '8px',
                  }}
                >
                  <Text type="sub-heading" color="#068FFF">
                    {btn.text || 'Button'}
                  </Text>
                </div>
              ))}
            </div>
          ))}

        {/* PRODUCT CAROUSEL */}
        {carouselType === 'PRODUCT' &&
          productCards?.map((_, index) => {
            const label = productCTAType === 'VIEW' ? 'View' : productCTA?.text || 'Button';

            return (
              <div
                key={index}
                style={{
                  minWidth: '220px',
                  background: '#fff',
                  borderRadius: '10px',
                  padding: '8px',
                }}
              >
                <div
                  style={{
                    height: '120px',
                    background: '#eee',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                  }}
                >
                  Product Image
                </div>

                <Text type="sub-heading">Product Name</Text>
                <Text type="sub-heading" color="grey">
                  ₹ Price
                </Text>

                <div
                  className="mt-2 p-2 text-center"
                  style={{
                    background: '#f5f6f7',
                    borderRadius: '8px',
                  }}
                >
                  <Text type="sub-heading" color="#068FFF">
                    {label}
                  </Text>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default MarketingCarouselPreview;
